/*
 * Module for helping persist user state
 */

rs.module("ui/framework/userstate-manager", [],

    function () {

        var _persistStateUrl;

        //
        // Initialize the manager
        //
        function initialize(persistStateUrl) {
            _persistStateUrl = persistStateUrl;
        }

        //
        // Persist the given state value using the given state key
        //
        function persist(stateKey, stateValue) {

            // Post back the state for server side storage.  Note the complete
            // lack of sensible error handling here (for now).
            $.post(_persistStateUrl, { stateKey, stateValue });
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            persist: persist
        };

        return exports;
    }
);